import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import CheckboxBlank from '@/assets/icons/checkbox-blank.svg';
import CheckboxMarked from '@/assets/icons/checkbox-marked.svg';
import CheckboxIndeterminate from '@/assets/icons/checkbox-indeterminate.svg';
import Dot from '@/assets/icons/circle-filled.svg';
import Eye from '@/assets/icons/eye.svg';
import EyeOff from '@/assets/icons/eye-off.svg';
import RadioOff from '@/assets/icons/radio-off.svg';
import RadioOn from '@/assets/icons/radio-on.svg';
import ChevronDown from '@/assets/icons/chevron-down.svg';
import ChevronLeft from '@/assets/icons/chevron-left.svg';
import ChevronRight from '@/assets/icons/chevron-right.svg';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#d7eef9', // blue
        secondary: { base: '#1592e6', darken1: '#0455DB' },
        journey: { base: '#d7eef9', lighten1: '#ebf7fc', lighten2: '#f1f8fd' },
        journeySecondary: { base: '#1592e6', darken1: '#0455DB' },
        deepening: { base: '#e9e0fe', lighten1: '#f4f0ff', lighten2: '#f9f8fe' },
        deepeningSecondary: '#9068de',
        lightening: { base: '#fff7a5', lighten1: '#fffac5', lighten2: '#fffef1' },
        lighteningSecondary: {
          // lighten1: '#FFE701',
          base: '#FFE701',
          darken1: '#f4dd00',
          darken2: '#efd200',
        },
        black: '#212121',
        anchor: '#0079ca',
        error: { base: '#ec407a', lighten1: '#fbd9e4' },
      },
      dark: {
        black: '#212121',
      },
    },
  },
  breakpoint: {
    thresholds: {
      xs: 340,
      sm: 600,
      md: 980,
      lg: 1440,
    },
  },
  icons: {
    values: {
      checkboxOff: {
        component: CheckboxBlank,
      },
      checkboxOn: {
        component: CheckboxMarked,
      },
      checkboxIndeterminate: {
        component: CheckboxIndeterminate,
      },
      delimiter: {
        component: Dot,
      },
      eye: {
        component: Eye,
      },
      eyeOff: {
        component: EyeOff,
      },
      radioOff: {
        component: RadioOff,
      },
      radioOn: {
        component: RadioOn,
      },
      dropdown: {
        component: ChevronDown,
      },
      prev: {
        component: ChevronLeft,
      },
      next: {
        component: ChevronRight,
      },
    },
  },
});
